import { ReactElement } from 'react';

import { FilterPanel } from '@dreryk/react-components';

import { protectFeature } from '~libs.shared.system';

import { GroupSessionsFilterPanelLoader } from './GroupSessionsFilterPanel.loader';
import { GroupSessionsFilterPanelFormBean } from './GroupSessionsFilterPanel.types';
import { HealthcareProviderLocationController } from './controllers/healthcareProviderLocation/HealthcareProviderLocationController';
import { ScheduleController } from './controllers/schedule/ScheduleController';
import { PractitionersController } from './controllers/practitioners/PractitionersController';
import { ServicesController } from './controllers/servicesController/ServicesController';
import { StatusController } from './controllers/status/StatusController';
import { GroupTypeController } from './controllers/groupType/GroupTypeController';
import { OccupancyController } from './controllers/occupancy/OccupancyController';
import { IssueController } from './controllers/issue/IssueController';

export const GroupSessionsFilterPanel = (): ReactElement | null => (
   <GroupSessionsFilterPanelLoader>
      {({ locations, practitioners, services }) => (
         <FilterPanel<GroupSessionsFilterPanelFormBean> testId={'groupSessionsFilterPanel'}>
            {({ registerController }) => (
               <>
                  {protectFeature('searchingAllPractitioners') ? (
                     <PractitionersController registerController={registerController} practitioners={practitioners} />
                  ) : null}
                  {protectFeature(
                     'searchingPrivateMedicalServices',
                     <ServicesController registerController={registerController} services={services} />
                  )}
                  <ScheduleController registerController={registerController} />
                  <StatusController registerController={registerController} />
                  <GroupTypeController registerController={registerController} />
                  <OccupancyController registerController={registerController} />
                  <HealthcareProviderLocationController locations={locations} registerController={registerController} />
                  <IssueController registerController={registerController} />
               </>
            )}
         </FilterPanel>
      )}
   </GroupSessionsFilterPanelLoader>
);
